module.exports = __webpack_public_path__ + "officialStatic/img/geliLogo.04ea9bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/geliLogo.png
// module id = cUXo
// module chunks = 0